import React from "react";
import { styled } from "goober";

import type { NavProfile } from "@/app/util.mjs";
import Dropdown from "@/inline-assets/dropdown.svg";
import { classNames } from "@/util/class-names.mjs";
import { sendInteractionEvent } from "@/util/use-interaction-event.mjs";

const Wrapper = styled("div")`
  & {
    display: flex;
    align-items: center;
  }
  .nav-profile-link {
    display: flex;
    align-items: center;
    gap: var(--sp-2);
    padding-inline-end: var(--sp-2);

    &:hover {
    }
    &.active {
    }
  }

  .game-avatar {
    flex-shrink: 0;
    border-radius: var(--sp-6);
    box-shadow: 0 0 0 2px var(--shade3);
  }

  .shard {
    display: flex;
    padding: 0 var(--sp-1);
    justify-content: center;
    align-items: center;
    gap: var(--sp-1);
    border-radius: var(--sp-1);
    background: var(--shade2-15);
    text-align: center;
  }

  .name {
    max-width: 10ch;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .tagline {
    opacity: 0.75;
  }
  .dropdown-icon {
    color: var(--shade1);
    cursor: pointer;

    &:hover {
      color: var(--shade0);
    }
  }
`;

export default function NavProfile({
  profile: { imgUrl, name, tagLine, shard, profileUrl },
  onClick,
  active,
}: {
  profile: NavProfile;
  onClick: () => void;
  active: boolean;
}) {
  return (
    <Wrapper>
      <a
        href={profileUrl}
        onClick={() => {
          sendInteractionEvent("app-navigation-nav-profile-link");
        }}
        {...classNames("nav-profile-link profile", active && "active")}
      >
        <img
          src={imgUrl}
          alt={name}
          width={24}
          height={24}
          className="game-avatar"
        />
        <span className="name type-form--button">
          <span>{name}</span>
          {tagLine && <span className="tagline"> #{tagLine}</span>}
        </span>
        {shard && <span className="shard type-caption--semi">{shard}</span>}
      </a>
      <Dropdown
        width="24"
        height="24"
        className="dropdown-icon"
        onClick={() => {
          onClick();
          sendInteractionEvent("app-navigation-nav-profile-dropdown");
        }}
      />
    </Wrapper>
  );
}
